class RoomPackageSelector {
  constructor(container) {
    this.container = container;
    this.select = container.querySelector('[data-room-package-select]');
    this.priceDisplay = container.querySelector('[data-room-package-price]');
    this.popupTrigger = container.querySelector('[data-room-package-popup-trigger]');
    this.popupModalSelector = container.dataset.roomPackagePopupModal;

    if (this.select && this.priceDisplay) {
      this.select.addEventListener('change', this.onSelectChange.bind(this));
      this.updatePrice();
    }

    if (!this.popupTrigger || !this.popupModalSelector) return;

    this.popupTrigger.addEventListener('click', this.onPopupTriggerClick.bind(this));
  }

  onSelectChange() {
    this.updatePrice();
  }

  updatePrice() {
    const selectedOption = this.select?.options[this.select.selectedIndex];
    const selectedPrice = selectedOption?.dataset.price;
    const defaultPrice = this.priceDisplay?.dataset.defaultPrice || '';

    this.priceDisplay.textContent = selectedPrice || defaultPrice;
  }

  onPopupTriggerClick(event) {
    event.preventDefault();

    const modal = document.querySelector(this.popupModalSelector);

    if (modal) {
      modal.show(this.popupTrigger);
    }
  }
}

class RoomPackageFaq {
  constructor(element) {
    this.element = element;
    this.summary = element.querySelector('summary');
    this.content = element.querySelector('.room-package-popup__faq-content');
    this.isAnimating = false;

    if (!this.summary || !this.content) return;

    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onSummaryClick(event) {
    event.preventDefault();

    if (this.isAnimating) return;

    if (this.element.open) {
      this.close();
      return;
    }

    this.open();
  }

  open() {
    this.isAnimating = true;
    this.element.classList.remove('is-closing');
    this.element.classList.add('is-opening');
    this.element.open = true;

    const endHeight = this.content.scrollHeight;

    this.content.style.height = '0px';

    requestAnimationFrame(() => {
      this.content.style.height = `${endHeight}px`;
    });

    this.content.addEventListener('transitionend', this.onOpenTransitionEnd);
  }

  close() {
    this.isAnimating = true;
    this.element.classList.remove('is-opening');
    this.element.classList.add('is-closing');

    const startHeight = this.content.scrollHeight;

    this.content.style.height = `${startHeight}px`;

    requestAnimationFrame(() => {
      this.content.style.height = '0px';
    });

    this.content.addEventListener('transitionend', this.onCloseTransitionEnd);
  }

  onOpenTransitionEnd = (event) => {
    if (event.propertyName !== 'height') return;

    this.content.removeEventListener('transitionend', this.onOpenTransitionEnd);
    this.content.style.height = 'auto';
    this.element.classList.remove('is-opening');
    this.isAnimating = false;
  };

  onCloseTransitionEnd = (event) => {
    if (event.propertyName !== 'height') return;

    this.content.removeEventListener('transitionend', this.onCloseTransitionEnd);
    this.content.style.height = '';
    this.element.open = false;
    this.element.classList.remove('is-closing');
    this.isAnimating = false;
  };
}

const initRoomPackageSelectors = () => {
  document.querySelectorAll('[data-room-package-selector]').forEach((container) => {
    if (!container.roomPackageSelector) {
      container.roomPackageSelector = new RoomPackageSelector(container);
    }
  });

  document.querySelectorAll('.room-package-popup__faq').forEach((faq) => {
    if (!faq.roomPackageFaq) {
      faq.roomPackageFaq = new RoomPackageFaq(faq);
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRoomPackageSelectors);
} else {
  initRoomPackageSelectors();
}
